import { DeleteIcon } from '@chakra-ui/icons';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  IconButton,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import { useRef } from 'react';

interface ConfirmRemoveRecurrenceClientButtonProps {
  isLoading?: boolean;
  onConfirm: () => Promise<void> | void;
}

const ConfirmRemoveRecurrenceClientButton: React.FC<ConfirmRemoveRecurrenceClientButtonProps> = ({
  isLoading,
  onConfirm,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <>
      <Tooltip label="Remover vínculo">
        <IconButton
          aria-label="Remover recorrência"
          icon={<DeleteIcon />}
          colorScheme="red"
          size="sm"
          ml={2}
          isLoading={isLoading}
          onClick={onOpen}
        />
      </Tooltip>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover recorrência do cliente
            </AlertDialogHeader>

            <AlertDialogBody>
              Remover este vínculo cliente x plano irá cancelar as cobranças pendentes desse cliente na recorrência.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Voltar
              </Button>
              <Button colorScheme="red" ml={3} isLoading={isLoading} onClick={handleConfirm}>
                Remover
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ConfirmRemoveRecurrenceClientButton;
